import styled from 'styled-components'

export const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 20px;
  background-color: #ebebeb;
  padding: 8px 12px;
  width: 100%;
  max-width: 390px;
  position: relative;
`

export const FileUploadLabel = styled.label`
  background-color: #fff;
  border-radius: 4px;
  padding: 3px 6px;
  cursor: pointer;
  margin-right: 8px;
  white-space: nowrap;
  font-size: 0.8rem;
`

export const FileNameText = styled.span`
  color: #666;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`
